module.exports = __webpack_public_path__ + "img/PM-login-img.546a795f.png";